<template>
  <div class="tab-pane fade" :class="{ 'active show': customizer == 'settings' }" id="c-pills-home" role="tabpanel"
    aria-labelledby="c-pills-home-tab">
    <h6>Layout Type</h6>
    <ul class="main-layout layout-grid">
      <li data-attr="ltr" :class="{ active: layoutType == 'ltr' }" @click="customizeLayoutType('ltr')">
        <div class="header bg-light">
          <ul>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
        <div class="body">
          <ul>
            <li class="bg-light sidebar"></li>
            <li class="bg-light body">
              <span class="badge badge-primary">LTR</span>
            </li>
          </ul>
        </div>
      </li>
      <li data-attr="rtl" :class="{ active: layoutType == 'rtl' }" @click="customizeLayoutType('rtl')">
        <div class="header bg-light">
          <ul>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
        <div class="body">
          <ul>
            <li class="bg-light body">
              <span class="badge badge-primary">RTL</span>
            </li>
            <li class="bg-light sidebar"></li>
          </ul>
        </div>
      </li>
      <li v-bind:style="boxlayout ? '' : 'display: none;'" data-attr="box" :class="{ active: layoutType == 'box-layout' }"
        @click="customizeLayoutType('box-layout')" class="box-layout px-3">
        <div class="header bg-light">
          <ul>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
        <div class="body">
          <ul>
            <li class="bg-light sidebar"></li>
            <li class="bg-light body">
              <span class="badge badge-primary">Box</span>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <h6 class="">Sidebar type</h6>
    <ul class="sidebar-type layout-grid">
      <li data-attr="normal-sidebar" @click="customizeSidebarSetting('horizontal-wrapper')">
        <div class="header bg-light">
          <ul>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
        <div class="body">
          <ul>
            <li class="bg-dark sidebar"></li>
            <li class="bg-light body"></li>
          </ul>
        </div>

      </li>
      <li data-attr="compact-sidebar" :class="{
        active: layout.settings.sidebar_setting == 'compact-sidebar',
      }" @click="customizeSidebarSetting('compact-sidebar')">
        <div class="header bg-light">
          <ul>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
        <div class="body">
          <ul>
            <li class="bg-dark sidebar compact"></li>
            <li class="bg-light body"></li>
          </ul>

        </div>
      </li>

    </ul>

  </div>
</template>
  
<script>
import { mapState } from 'vuex';

export default {
  name: 'customSetting',
  data() {
    return {
      layoutType: 'ltr',
      mixLayout: 'default',
    };
  },
  computed: {
    ...mapState({
      customizer: (state) => state.menu.customizer,
      layout: (state) => state.layout.layout,
      data: (state) => JSON.stringify(state.layout.layout),
      boxlayout: (state) => state.layout.boxlayout,

    }),
  },
  methods: {
    customizeLayoutType(val) {
      this.$store.dispatch('layout/setLayoutType', {
        class: val,
        val: true
      });
      this.layoutType = val;
    },
    customizeSidebarSetting(val) {
      this.layout.settings.sidebar_setting = val;
      this.$store.dispatch('layout/setCustomizeSidebarType', val)
    },
    customizeColor() {
      const primary = document.getElementById('ColorPicker1').value;
      const secondary = document.getElementById('ColorPicker2').value;
      this.$store.dispatch('layout/setColorScheme', { primary, secondary });
    },
    resetColor() {
      localStorage.setItem('primary_color', '#7366ff');
      localStorage.setItem('secondary_color', '#f73164');
      window.location.reload();
    },
    customizeMixLayout(val) {
      this.mixLayout = val;
      this.$store.dispatch('layout/setLayout', val);
    },
  },
};
</script>